import { useEffect, useState } from 'react';

import { useWeb3 } from '@/hooks/use-web3';
import { ShortenAddr } from '@/lib/Shorten';
import { copys } from '@/lib/util';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Balance from '../balance';
import { COIN_NAME_SFL, POLYGON_AMOY, POLYGON_MAIN, POLYGON_SHUFFLE } from '@/lib/common/name-space';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Box, Typography, useTheme } from '@mui/material';

import BalanceSvg from '@/assets/assetfi/Balance';
import PortfolioSvg from '@/assets/assetfi/Portfolio';
import SymbolSvg from '@/assets/assetfi/Symbol';
import CopySvg from '@/assets/assetfi/Copy';
import DisconnectSvg from '@/assets/assetfi/Disconnect';
import UsdtBalance from '../balance/UsdtBalance';

import { useWeb3AuthConnect } from '@web3auth/modal/react';
import { useWeb3AuthDisconnect } from '@web3auth/modal/react';
export interface SimpleDialogProps {
  open: boolean;
  handleClose: any;
  anchorEl?: HTMLElement | null;
}

export default function ConnectInfo(props: SimpleDialogProps) {
  const { handleClose, open, anchorEl } = props;

  const [address, setAddress] = useState('');
  const { web3authCall, address: addr, clearWeb3Auth } = useWeb3();
  const { isConnected } = useWeb3AuthConnect();
  const { disconnect } = useWeb3AuthDisconnect();

  const theme = useTheme();
  const navigate = useNavigate();

  useEffect(() => {
    if (address) {
      return;
    }
    (async () => {
      if (isConnected && addr) {
        setAddress(addr);
        return;
      }
    })();

    return () => {};
  }, [isConnected, web3authCall, addr]);

  return (
    <>
      <Menu
        sx={{
          marginTop: '7.36px',
          padding: 0,
          '& .MuiMenu-list': {
            padding: 0,
          },
          '& .MuiPaper-root': {
            borderRadius: '10px',
            padding: 0,
            margin: 0,
          },
        }}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box sx={{ width: '320px' }}>
          <MenuItem
            onClick={() => {
              copys(String(address));
              toast.success('지갑 주소가 복사되었습니다.');
              // navigator.clipboard.writeText('OxF9sd7...08dsl');
            }}
            sx={{
              padding: '16px',
              borderBottom: `0.5px solid ${theme.greyscale.lightgrey1}`,
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
              <SymbolSvg width={16} height={16} />
              <Typography variant="h6" color={theme.greyscale.darkgrey2}>
                {ShortenAddr(address)}
              </Typography>
            </Box>
            <CopySvg width={14} height={14} />
          </MenuItem>
          <MenuItem
            sx={{
              padding: '16px',
              borderBottom: `0.5px solid ${theme.greyscale.lightgrey1}`,
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
              <BalanceSvg width={18} height={18} />
              <Typography variant="subtitle1" color={theme.greyscale.darkgrey2}>
                Balance
              </Typography>
            </Box>
            <Box sx={{ alignSelf: 'flex-end', textAlign: 'right' }}>
              <Typography
                sx={{
                  fontSize: '24px',
                  fontWeight: '600',
                  lineHeight: '34px',
                  letterSpacing: '-0.02em',
                }}
                color={theme.background.blue}
              >
                <Balance
                  symbol={COIN_NAME_SFL}
                  chainId={process.env.NODE_ENV === 'production' ? POLYGON_MAIN : POLYGON_AMOY}
                  token={POLYGON_SHUFFLE}
                />
              </Typography>
              <Typography variant="body2" color={theme.background.blue}>
                ~{' '}
                <UsdtBalance
                  symbol={COIN_NAME_SFL}
                  chainId={process.env.NODE_ENV === 'production' ? POLYGON_MAIN : POLYGON_AMOY}
                  token={POLYGON_SHUFFLE}
                />
              </Typography>
            </Box>
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleClose();
              navigate('/portfolio');
            }}
            sx={{
              padding: '16px',
              borderBottom: `0.5px solid ${theme.greyscale.lightgrey1}`,
            }}
          >
            <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
              <PortfolioSvg width={18} height={18} />
              <Typography variant="subtitle1" color={theme.greyscale.darkgrey2}>
                Portfolio
              </Typography>
            </Box>
          </MenuItem>
          <MenuItem
            onClick={async () => {
              handleClose();
              if (!isConnected) {
                return;
              }
              // setIsWeb3Connect(false);

              await disconnect();
              clearWeb3Auth();
              window.location.reload();
              // const path = location.pathname;
              // if (path === '/pools') {
              //   window.location.reload();
              // } else {
              //   navigate('/pools');
              // }

              // setWallet(false);
            }}
            sx={{
              padding: '16px',
            }}
          >
            <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
              <DisconnectSvg width={18} height={18} />
              <Typography variant="subtitle1" color={theme.greyscale.darkgrey2}>
                Disconnect
              </Typography>
            </Box>
          </MenuItem>
        </Box>
      </Menu>

      {/* <Dialog onClose={handleClose} open={open}>
        <DialogTitle>
          {ShortenAddr(address)}{' '}
          <IconButton
            sx={{
              p: 0.5,
            }}
            onClick={() => {
              copys(String(address));
              toast.success('지갑 주소가 복사되었습니다.');
            }}
          >
            <SFCopyIcon color={'black'} />
          </IconButton>
        </DialogTitle>
        <List sx={{ pt: 0 }}>
          <ListItem disableGutters>
            <ListItemButton>
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                  <PersonIcon />
                </Avatar>
              </ListItemAvatar>
              <Balance symbol={COIN_NAME_TRI} chainId={POLYGON_AMOY} token={POLYGON_TRI} />
            </ListItemButton>
          </ListItem>

          <ListItem disableGutters>
            <ListItemButton
              onClick={() => {
                navigate('/portfolio');
              }}
            >
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                  <PersonIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Portfolio" />
            </ListItemButton>
          </ListItem>

          <ListItem disableGutters>
            <ListItemButton
              onClick={async () => {
                if (!web3authCall) {
                  return;
                }
                await web3authCall.logout();
                const path = location.pathname;
                if (path === '/pools') {
                  window.location.reload();
                } else {
                  navigate('/pools');
                }
                //              navigate('/logout');
              }}
            >
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                  <PersonIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Disconnect" />
            </ListItemButton>
          </ListItem>
        </List>
      </Dialog> */}
    </>
  );
}
